// ToastMessage.tsx
import { Alert, Snackbar } from "@mui/material";

export type ToastSeverity = "success" | "error" | "info" | "warning";

interface ToastMessageProps {
  open: boolean;
  onClose: () => void;
  severity: ToastSeverity;
  message: string;
}

const severityStyles: Record<ToastSeverity, any> = {
  success: {
    bgcolor: "#d4edda",
    color: "#155724",
    border: "1px solid #c3e6cb",
  },
  error: {
    bgcolor: "#f8d7da",
    color: "#721c24",
    border: "1px solid #f5c6cb",
  },
  warning: {
    bgcolor: "#fff3cd",
    color: "#856404",
    border: "1px solid #ffeeba",
  },
  info: {
    bgcolor: "#d1ecf1",
    color: "#0c5460",
    border: "1px solid #bee5eb",
  },
};

const ToastMessage = ({
  open,
  onClose,
  severity,
  message,
}: ToastMessageProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={onClose}
    >
      <Alert
        severity={severity}
        onClose={onClose}
        sx={{
          display: "flex",
          alignItems: "center",
          ...severityStyles[severity],
          fontSize: "0.875rem",
          "& .MuiAlert-message": {
            display: "flex",
            alignItems: "center",
          },

          "& .MuiAlert-action": {
            alignItems: "center",
            paddingTop: 0,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastMessage;
